export default "__VITE_ASSET__CPWDDSmK__"